import {importProvidersFrom} from "@angular/core";
import {EffectsModule} from "@ngrx/effects";
import {StoreModule} from "@ngrx/store";
import {AddonPermissionGuard} from "../../../addon-permission/addon-permission.guard";
import {LEGAL_HUB_URL} from "./legal-hub-consts";
import {LegalHubPlaybooksListingFeatureKey} from "./store/playbooks.config";
import {PlaybooksListingEffects} from "./store/playbooks.effects";
import {playbookListeningReducers} from "./store/playbooks.reducers";
import { AddonKeys } from "../addons/addons/addon-keys.enum";

export const routes = [
    {
        path: LEGAL_HUB_URL ,
        loadComponent:()=> import('./legal-hub-playbooks-listening/legal-hub-playbooks-listening.component').then(m => m.LegalHubPlaybooksListeningComponent),
        data: { animation: 'zoom-in', addon_key: AddonKeys.LH },
        canActivate: [AddonPermissionGuard],
        providers:[
            importProvidersFrom(
                // register feature reducer
                StoreModule.forFeature(LegalHubPlaybooksListingFeatureKey, playbookListeningReducers),
                // run feature effects
                EffectsModule.forFeature([PlaybooksListingEffects])
            )
        ],
    }
];